export default Object.freeze({
  loading: false,
  error: null,
  languages: [],
});
